import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrustContentModule } from '../../../pipes/trust-content/trust-content.module';
import { GenericContentComponent } from './generic-content.component';

@NgModule({
  imports: [CommonModule, TrustContentModule],
  declarations: [GenericContentComponent],
  exports: [GenericContentComponent]
})
export class GenericContentModule {}
